import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, CrmActionCreators, IProductListResponse, IStaffListResponse, DutyOfficerScheduleActionCreators } from '@nkr/store/index';
import { IBaseResponse, IContact, IProduct } from '@nkr/models/index';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { GridApi, GridReadyEvent, CsvExportParams, ProcessCellForExportParams } from 'ag-grid-community';
import Grid from './grid';

interface IOwnProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getProducts: () => Promise<IProductListResponse>,
    getStaff: () => Promise<IStaffListResponse>
    updateProductOwner: (productId: number, owner: string) => Promise<IBaseResponse>,
    updateProductIsActive: (productId: number, isActive: boolean) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    productList: IProduct[],
    staffList: IContact[],
    gridApi: GridApi
}

class Products extends React.Component<TProps, IState> {
    readonly state: IState = {
        productList: [],
        staffList: [],
        gridApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading products, one moment please...').then(() => {
            Promise.all([
                this.props.getProducts(),
                this.props.getStaff()
            ]).then((response: [IProductListResponse, IStaffListResponse]) => {
                if (response[0].data.success && response[1].data.success) {
                    this.setState({
                        productList: response[0].data.results,
                        staffList: response[1].data.results
                    }, () => {
                        this.state.gridApi.refreshCells({ force: true });
                        this.props.hideLoading();
                    });
                } else {
                    this.props.hideLoading();
                }
            });
        });
    }

    handleIsActiveChange = (productId: number, isActive: number) => {
        this.props.showLoading('Updating product active status, one moment please...').then(() => {
            this.props.updateProductIsActive(productId, isActive == 1).then(response => {
                if (response.data.success) {
                    this.props.getProducts().then(response => {
                        if (response.data.success) {
                            this.setState({
                                productList: response.data.results
                            }, () => {
                                this.props.hideLoading();
                                toast.success('Product is-active updated successfully');
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    })
                } else {
                    this.props.hideLoading();
                    toast.error('Unable to update product is-active');
                }
            });
        });
    }

    handleOwnerChange = (productId: number, owner: string) => {
        this.props.showLoading('Updating product owner, one moment please...').then(() => {
            this.props.updateProductOwner(productId, owner).then(response => {
                if (response.data.success) {
                    this.props.getProducts().then(response => {
                        if (response.data.success) {
                            this.setState({
                                productList: response.data.results
                            }, () => {
                                this.props.hideLoading();
                                toast.success('Product owner updated successfully');
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    })
                } else {
                    this.props.hideLoading();
                    toast.error('Unable to update product owner');
                }
            });
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'product-list.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colId = params.column.getColId();

                if (colId == 'active') {
                    return params.value ? 'Yes' : 'No';
                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        return (
            <>
                <div className='container'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20 }}>
                        <div style={{ flexBasis: '33%', fontSize: 28, fontWeight: 500 }}>
                            PRODUCTS
                        </div>
                        <div>
                            <Button onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>

                    <Grid
                        data={this.state.productList}
                        staffList={this.state.staffList}
                        onGridReady={this.onGridReady}
                        onActiveChange={this.handleIsActiveChange}
                        onOwnerChange={this.handleOwnerChange} />
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return null;
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getProducts: () => {
            return dispatch(CrmActionCreators.getProducts());
        },
        getStaff: () => {
            return dispatch(DutyOfficerScheduleActionCreators.getStaffList());
        },
        updateProductOwner: (productId, owner) => {
            return dispatch(CrmActionCreators.updateProductOwner(productId, owner));
        },
        updateProductIsActive: (productId, isActive) => {
            return dispatch(CrmActionCreators.updateProductIsActive(productId, isActive));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Products);